<div class="onhover-click">
<!--  <div class="sidebar-image" (click)="isProfile=!isProfile">-->
<!--    <img src="assets/images/user.png" alt="profile">-->
<!--    <span class="status status-success"></span>-->
<!--  </div>-->
    <div class="rounded-border">
        <div class="circle-success">
            <p class="txt-primary">{{userLogged?.nameShort}}</p>
        </div>
    </div>

  <div class="sidebar-content nameUser">
    <h4>{{userLogged?.name}}</h4><span class="f-12 f-w-600 f-light">{{userLogged?.description}}</span>
  </div>
</div>
<ul class="profile-dropdown onhover-show-div" [class.active]="isProfile">
  <li><a (click)="logout()">
      <div class="profile-icon">
        <app-common-svg-icons></app-common-svg-icons>
      </div><span>Cerrar sesión</span></a></li>
</ul>
